import React, {PropsWithChildren, Ref} from 'react';
import clsx from 'clsx';

import Loading from '../Loading';

import styles from './Button.module.css';

export interface ButtonProps extends PropsWithChildren<{
  id?: string
  className?: string
  disabled?: boolean
  loading?: boolean

  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}> {
}


const Button = (props: PropsWithChildren<ButtonProps>, ref: Ref<HTMLButtonElement>) => {

  return (
    <button
      ref={ref}
      id={props.id}
      className={clsx(styles.root, props.className)}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <span>{props.children}</span>
      {
        props.loading &&
        <Loading size="28px" color={'#3ACE85'}/>
      }
    </button>
  );
};

export default React.forwardRef(Button);
